import { Component, OnInit, OnDestroy } from '@angular/core';
import { ManageService } from '../../../services/manage.service';
import { AnnuityItemsViewModel } from '../../../models/annuity-view.model';
import { CommonService } from '../../../services';
import { Router, ActivatedRoute } from '@angular/router';
// tslint:disable-next-line:import-blacklist
import { Subject } from 'rxjs';
import { takeUntil } from 'rxjs/operators';

@Component({
  selector: 'app-add-addon',
  templateUrl: './add-addon.component.html',
  styleUrls: ['./add-addon.component.css']
})
export class AddAddonComponent implements OnInit, OnDestroy {

  addonList: AnnuityItemsViewModel[] = [];
  addonListFilter: AnnuityItemsViewModel[] = [];
  addonListPendingList: AnnuityItemsViewModel[] = [];
  searchAddon: string;
  loadContent = false;
  tenantId: string;
  ngUnsubscribe: Subject<void> = new Subject<void>();
  title = 'Add Addon';

  constructor(
    private manageService: ManageService,
    private commonService: CommonService,
    private activatedRoute: ActivatedRoute,
    private router: Router
  ) { }

  ngOnInit() {
    $('#levelOne').animate({ scrollLeft: $('#managecsp').width() + 505 }, 400);
    this.activatedRoute.parent.url.pipe(takeUntil(this.ngUnsubscribe)).subscribe(url => {
      this.tenantId = url[1].path;
    },
      (error: any) => {
        console.error(error);
        this.loadContent = true;
      });

    this.activatedRoute.url.pipe(takeUntil(this.ngUnsubscribe)).subscribe(res => {
      if (res && res.length === 3) {
        this.loadContent = false;
        this.manageService.GetCSPAddonItems(res[1].path, res[2].path).subscribe((model: AnnuityItemsViewModel[]) => {
          this.addonList = model;
          this.addonList.forEach(item => {
            item.quantity = '1';
            item.minMaxQtyText = '';
            if (item.minQty) {
              item.minMaxQtyText += 'Min Order Qty - ' + item.minQty + ' ';
            }
            if (item.maxQty) {
              item.minMaxQtyText += 'Max Order Qty - ' + item.maxQty + ' ';
            }
          });
          this.addonListFilter = this.addonList;
          this.loadContent = true;
        },
          (error: any) => {
            console.error(error);
            this.loadContent = true;
          });
      }
    },
      (error: any) => {
        console.error(error);
        this.loadContent = true;
      });
  }

  filterAddon(): void {
    this.addonListFilter = this.addonList.filter(annuityItem => annuityItem.description.toLowerCase().includes(this.searchAddon.toLowerCase()) || annuityItem.stockCode.toLowerCase().includes(this.searchAddon.toLowerCase()));
  }

  AddAddon(annuityItem: AnnuityItemsViewModel): void {
    this.loadContent = false;
    if (!this.addonListPendingList.filter(item => item.stockCode === annuityItem.stockCode).length) {
      annuityItem.editMPN = true;
      annuityItem.totalPrice = this.commonService.toNumber(annuityItem.itemPrice.replace('$', '')) * this.commonService.toNumber(annuityItem.quantity);
      this.addonListPendingList.push(new AnnuityItemsViewModel(annuityItem));
    } else {
      this.getItemFromList(annuityItem.stockCode).quantity = (this.commonService.toNumber(this.getItemFromList(annuityItem.stockCode).quantity) + this.commonService.toNumber(annuityItem.quantity)).toString();
      this.getItemFromList(annuityItem.stockCode).totalPrice = this.commonService.toNumber(annuityItem.itemPrice.replace('$', '')) * this.commonService.toNumber(annuityItem.quantity);
    }
    this.loadContent = true;
    // this.commonService.showSuccess("#" + annuityItem.stockCode, "New Item added", "right");
    this.commonService.implementToast('New Item added', 'Success');
  }

  /**
   * Get actual annuity item from current add-on pending list by stock code
   * 
   */
  getItemFromList(stockCode: String): AnnuityItemsViewModel {
    return this.addonListPendingList.filter(item => item.stockCode === stockCode)[0];
  }

  finishAddAddon(): void {
    this.manageService.monitorPendingAddon(this.addonListPendingList);
    this.manageService.monitorSelectedTabIndex(0);
    this.manageService.backToTenentPage(this.tenantId);
  }

  close() {
    this.manageService.monitorPendingAddon(this.addonListPendingList);
    this.manageService.monitorSelectedTabIndex(0);
    this.manageService.backToTenentPage(this.tenantId);
  }

  onLoading(currentLoadingStatus: boolean) {
    this.loadContent = !currentLoadingStatus;
  }


  ngOnDestroy() {
    this.ngUnsubscribe.next();
    this.ngUnsubscribe.complete();
  }
}
